// Configuración de páginas de confirmación tras pago/agenda.
// Cada slug se renderiza como /gracias/:slug

export type ConfirmationType = "subscription" | "one-time" | "booking";

export interface ConfirmationConfig {
  slug: string;
  type: ConfirmationType;
  product: string;
  price?: string;
  billing?: string;
  description: string;
  nextSteps: { title: string; description: string }[];
}

export const CONFIRMATIONS: ConfirmationConfig[] = [
  // ===== PLANES MENSUALES =====
  {
    slug: "plan-1-servicio",
    type: "subscription",
    product: "Plan 1 servicio",
    price: "199€",
    billing: "/mes IVA incluido",
    description:
      "Has activado tu suscripción mensual. Incluye 1 servicio recurrente a elegir entre los 8, gestionado cada mes por el equipo de producción de Vibra.",
    nextSteps: [
      { title: "Recibirás un email de bienvenida", description: "En menos de 24h con tu factura y acceso a la plataforma de Vibra." },
      { title: "Te contactaremos para el onboarding", description: "Agendaremos tu primera reunión y elegirás el servicio que quieres activar." },
      { title: "Empezamos a trabajar", description: "Tu equipo de Vibra se pone manos a la obra desde el día uno." },
    ],
  },
  {
    slug: "plan-2-servicios",
    type: "subscription",
    product: "Plan 2 servicios",
    price: "490€",
    billing: "/mes IVA incluido",
    description:
      "Has activado tu suscripción mensual. Incluye 2 servicios recurrentes a elegir, coordinados por una misma persona de tu cuenta.",
    nextSteps: [
      { title: "Recibirás un email de bienvenida", description: "En menos de 24h con tu factura y acceso a la plataforma de Vibra." },
      { title: "Te contactaremos para el onboarding", description: "Agendaremos tu primera reunión y elegirás los 2 servicios que quieres activar." },
      { title: "Empezamos a trabajar", description: "Tu equipo de Vibra se pone manos a la obra desde el día uno." },
    ],
  },
  {
    slug: "plan-4-servicios",
    type: "subscription",
    product: "Plan 4 servicios",
    price: "1.290€",
    billing: "/mes IVA incluido",
    description:
      "Has activado tu suscripción mensual. Tu equipo de marketing con project manager: 4 servicios recurrentes, reunión semanal y urgencias en 48 horas.",
    nextSteps: [
      { title: "Recibirás un email de bienvenida", description: "En menos de 24h con tu factura y acceso a la plataforma de Vibra." },
      { title: "Te contactaremos para el onboarding", description: "Agendaremos tu primera reunión semanal y elegirás los 4 servicios que quieres activar." },
      { title: "Empezamos a trabajar", description: "Tu equipo de Vibra se pone manos a la obra desde el día uno." },
    ],
  },


  // ===== SERVICIOS DE PAGO ÚNICO =====
  {
    slug: "branding",
    type: "one-time",
    product: "Branding",
    price: "500€",
    billing: "pago único · financiable a 3 meses 0%",
    description:
      "Has contratado tu pack de Branding: logo, brandbook e identidad visual completa.",
    nextSteps: [
      { title: "Recibirás un email con tu factura", description: "En menos de 24h con el resumen del proyecto." },
      { title: "Sesión de descubrimiento", description: "Conocemos tu marca, valores y referencias visuales." },
      { title: "Entrega en 3-4 semanas", description: "Recibirás logo, variantes, brandbook y aplicaciones." },
    ],
  },
  {
    slug: "embudo-ventas",
    type: "one-time",
    product: "CRM",
    price: "900€",
    billing: "pago único · financiable a 3 meses 0%",
    description:
      "Has contratado tu CRM con Kommo: setup, pipeline y automatizaciones incluidas.",
    nextSteps: [
      { title: "Recibirás un email con tu factura", description: "En menos de 24h con los siguientes pasos." },
      { title: "Reunión de descubrimiento", description: "Definimos tu proceso comercial y etapas del pipeline." },
      { title: "Implementación y formación", description: "Configuramos Kommo y formamos a tu equipo en 2-3 semanas." },
    ],
  },

  // ===== CONSULTORÍA AGENDADA (Cal.com) =====
  {
    slug: "consultoria-agendada",
    type: "booking",
    product: "Consultoría gratuita agendada",
    description:
      "Tu llamada de 20 minutos con el equipo de Vibra está confirmada. Recibirás un email con el enlace de la videollamada.",
    nextSteps: [
      { title: "Revisa tu email", description: "Encontrarás el enlace de la videollamada y el evento en tu calendario." },
      { title: "Prepara tus objetivos", description: "Piensa qué quieres conseguir en los próximos 3-6 meses para aprovechar la llamada." },
      { title: "Conéctate puntual", description: "Te esperamos a la hora reservada. Si necesitas reprogramar, usa el enlace del email." },
    ],
  },
  {
    slug: "reunion-adrian",
    type: "booking",
    product: "Reunión con Adrián confirmada",
    description:
      "Tu reunión con Adrián Garibaldi, fundador y CMO de Vibra Marketing, está confirmada. Recibirás un email con el enlace de la videollamada.",
    nextSteps: [
      { title: "Revisa tu email", description: "Encontrarás el enlace de la videollamada y el evento añadido a tu calendario." },
      { title: "Prepara tus objetivos", description: "Piensa qué quieres conseguir en los próximos 3-6 meses para sacarle el máximo a la reunión con Adrián." },
      { title: "Conéctate puntual", description: "Te esperamos a la hora reservada. Si necesitas reprogramar, usa el enlace del email." },
    ],
  },
  {
    slug: "consultoria-rosy",
    type: "booking",
    product: "Consultoría con Rosy confirmada",
    description:
      "Tu consultoría con Rosy del equipo de Vibra Marketing está confirmada. Recibirás un email con el enlace de la videollamada.",
    nextSteps: [
      { title: "Revisa tu email", description: "Encontrarás el enlace de la videollamada y el evento añadido a tu calendario." },
      { title: "Prepara tus dudas", description: "Anota las preguntas y retos que quieras resolver con Rosy para aprovechar al máximo la sesión." },
      { title: "Conéctate puntual", description: "Te esperamos a la hora reservada. Si necesitas reprogramar, usa el enlace del email." },
    ],
  },
];

export const CONFIRMATION_SLUGS = CONFIRMATIONS.map((c) => c.slug);
